const PLAN_IDENTITY_VERSION = "brief-profile-plan-v1";

function normalizedCountry(value) {
  const country = String(value || "US")
    .trim()
    .toUpperCase()
    .slice(0, 2);
  return /^[A-Z]{2}$/.test(country) ? country : "US";
}

function normalizedValues(values, { sorted = false } = {}) {
  const seen = new Set();
  const normalized = (Array.isArray(values) ? values : [])
    .map((value) => String(value || "").trim())
    .filter((value) => {
      if (!value || seen.has(value)) return false;
      seen.add(value);
      return true;
    });
  return sorted ? normalized.sort() : normalized;
}

/**
 * Mirrors Android's Brief profile-plan identity. Names and timestamps are
 * deliberately excluded so cosmetic sync writes do not invalidate a Journey.
 */
export function briefProfilePlanIdentity(profile, marketCountry) {
  if (!profile || typeof profile !== "object") return null;
  const profileId = String(profile.id || "").trim();
  if (!profileId) return null;
  const components = [
    PLAN_IDENTITY_VERSION,
    `profile:${profileId}`,
    `market:${normalizedCountry(marketCountry)}`,
    `template:${String(profile.templateId || "").trim()}`,
    `purpose:${String(profile.purpose || "").trim()}`,
    `length:${String(profile.preferredLength || "").trim()}`,
    `tone:${String(profile.tone || "").trim()}`,
    `time:${String(profile.timeOfDay || "").trim()}`,
    `narration:${profile.narrationEnabled === true}`,
    `language:${String(profile.languageCode || "")
      .trim()
      .toLowerCase()
      .replaceAll("_", "-")}`,
    ...normalizedValues(profile.sectionIds).map((sectionId) => `section:${sectionId}`),
    ...normalizedValues(profile.disabledSectionIds, { sorted: true }).map(
      (sectionId) => `disabled:${sectionId}`,
    ),
  ];
  return components.map((component) => `${component.length}:${component}`).join("");
}

/**
 * Brief Journey snapshots contain access-shaped content. Fence them by the
 * currently verified entitlement so an upgrade or expiry always rebuilds the
 * Journey instead of reviving a stale locked or unlocked snapshot.
 */
export function briefSessionPlanIdentityForEntitlement(profilePlanIdentity, hasPremiumAccess) {
  const normalizedPlanIdentity = String(profilePlanIdentity || "").trim();
  if (!normalizedPlanIdentity) return null;
  const entitlement = hasPremiumAccess === true ? "premium" : "free";
  const accessComponent = `entitlement:${entitlement}`;
  return `${normalizedPlanIdentity}${accessComponent.length}:${accessComponent}`;
}
